import { Fragment } from "react";
import Correction from "../Correction";

export default function CorrectionResults(props) {
    const { corrections } = props;
    
    return (
        <>
            {corrections.map((sentences, sentenceIndex) => (
                <Fragment key={`sentence-${sentenceIndex}`}>
                {sentenceIndex > 0 && <br />}

                {sentences.map((sentence, index) => (
                    <Fragment key={index}>
                        {sentence.isCorrect ? (
                            sentence.expected
                        ) : (
                           <Correction {...sentence} />
                        )}
                    </Fragment>
                ))}
                </Fragment>
            ))}
        </>
    )
}